import React from 'react';
import {useField} from 'formik';
import Slider, {Props as SliderProps} from './slider';

/**
  For use in Formik forms.

  Usage example:
  <FormikSlider name="startDate" min={1} max={36} step={1} />
*/

const FormikSlider = (props: {name: string} & SliderProps) => {
  const [field, meta] = useField(props.name);
  return <Slider {...props} {...field} error={meta.touched ? meta.error : ''} />;
};

export default FormikSlider;
